import {Component, Inject, OnInit, TemplateRef} from '@angular/core';
import { CommonModule } from "@angular/common";
import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import {MatListModule} from "@angular/material/list";

export enum ConfirmDialogAction {
  Confirm = 'CONFIRM',
  Cancel = 'CANCEL'
}

export interface ConfirmDialogComponentData {
  confirmMessage?: string
  title?: string
  template?: TemplateRef<any>;
  confirmBtnTxt?: string
  cancelBtnTxt?: string
}

@Component({
  standalone: true,
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatListModule
  ],
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {
  ConfirmDialogAction = ConfirmDialogAction

  get title (): string {
    return this.data.title ?? 'Confirmation'
  }

  get confirmMessage (): string {
    return this.data.confirmMessage ?? 'Are you sure you want to perform this action?'
  };

  get confirmBtnTxt (): string {
    return this.data.confirmBtnTxt ?? 'Confirm'
  }

  get cancelBtnTxt (): string {
    return this.data.cancelBtnTxt ?? 'Cancel'
  }

  constructor (
    @Inject(MAT_DIALOG_DATA) protected readonly data: ConfirmDialogComponentData
  ) {
  }

  ngOnInit (): void {
  }
}
